import React from "react";

import { Icon, type IconName } from "./icons";

export function EmptyState({
  icon = "activity",
  title,
  children,
  action,
  compact,
}: {
  icon?: IconName;
  title: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  compact?: boolean;
}) {
  return (
    <div className={`ds-empty${compact ? " compact" : ""}`}>
      <span className="ds-empty-icon" aria-hidden>
        <Icon name={icon} size={18} />
      </span>
      <div className="ds-empty-title">{title}</div>
      {children && <div className="ds-empty-body">{children}</div>}
      {action && <div className="ds-empty-action">{action}</div>}
    </div>
  );
}

/** Grey placeholder blocks shaped like the content that's loading. */
export function Skeleton({
  lines = 3,
  height,
}: {
  lines?: number;
  height?: number;
}) {
  if (height)
    return (
      <div
        className="ds-skel"
        style={{ height }}
        aria-busy
        aria-label="Loading"
      />
    );
  return (
    <div className="ds-skel-lines" aria-busy aria-label="Loading">
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="ds-skel" />
      ))}
    </div>
  );
}
